let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7Yj9o")).then(() => parcelRequire('6jwGQ'));